import { useEffect } from "react";
import { useSelector } from "react-redux";
import { CustomCard, Title } from "../../Utils/UI/Text";
import ShopifyDistancesBoard from "./ShopifyDistancesBoard";
import { getShopifyDistances } from "../Application/ShopifyDistances.business";
import {
  getShopifyDistancesSelector,
  getShopifyDistancesCountSelector,
} from "../Infrastructure/ShopifyDistances.reducer";
import NewShopifyDistances from "./NewShopifyDistances";
import "./ShopifyDistances.css";
import ExportButtonElement from "../../Layout/DesignSystem/ExportButton/Button";

const ShopifyDistances = () => {
  const shopifyDistances = useSelector(getShopifyDistancesSelector);
  const totalCounShopifyDistances = useSelector(
    getShopifyDistancesCountSelector
  );

  useEffect(() => {
    getShopifyDistances();
  }, []);
  return (
    <>
      <Title
        children="Distancias de Shopify"
        childrenTwo={<NewShopifyDistances />}
        childrenThree={
          <ExportButtonElement type={"shopifyDistances"} text={"Exportar"} />
        }
      />
       <CustomCard>
        <ShopifyDistancesBoard
          shopifyDistances={shopifyDistances}
          getShopifyDistances={getShopifyDistances}
          totalCounShopifyDistances={totalCounShopifyDistances}
        />
     </CustomCard>
    </>
  );
};

export default ShopifyDistances;
